/**
 * StreamReportsCtrl controller
 *
 * @class StreamReportsCtrl
 * @memberof mwApp/streamReports
 * @see mwApp/streamReports
 * @mixes mwApp/common.mixin:tabsCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/streamReports.controller:StreamReportsCtrl
 */
/* @ngInject */
export default function StreamReportsCtrl ($scope, authSvc) {
  var vm = this
  vm.mixes = authSvc.hasAccess('createStreamReport')
    ? [['tabsCtrlMixin', '', 'stream_reports', 'reports_list', 'generated_reports']]
    : [['tabsCtrlMixin', '']]

  /**
   * Methods to change tab
   *
   * @memberof mwApp/reports.controller:StreamReportsCtrl
   */
  vm.toChangeTab = function (tabName) {
    $scope.$broadcast(`dispatch: ${tabName}`)
  }
}
